import React, { Component } from "react";
import { NavBar, SideBar, Footer } from "../../components";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import usuarioModel from "../../models/usuario";
import produtoModel from "../../models/produto";
import vendedorModel from "../../models/vendedor";
import axios from "axios";
import queryString from "query-string";
const { formatarReal, formatarRealCarrinho } = require("../../utils");
PouchDB.plugin(PouchdbFind);

let VALIDAR_ESTOQUE = localStorage.getItem("validarEstoque");
if (VALIDAR_ESTOQUE === null) {
  VALIDAR_ESTOQUE = true;
} else {
  VALIDAR_ESTOQUE = VALIDAR_ESTOQUE === "true" ? true : false;
}

export default class Carrinho extends Component {
  constructor(props) {
    super(props);
    this.removeItemCarrinho = this.removeItemCarrinho.bind(this);
    this.notificar = this.notificar.bind(this);
    this.loadUsuario = this.loadUsuario.bind(this);
    this.calcularTotalCarrinho = this.calcularTotalCarrinho.bind(this);
    this.calcularValorDesconto = this.calcularValorDesconto.bind(this);
    this.toggle = this.toggle.bind(this);
    this.loadParametros = this.loadParametros.bind(this);
    this.onClickButtonQtd = this.onClickButtonQtd.bind(this);
    this.handleChangeQtd = this.handleChangeQtd.bind(this);
    this.getTipoAtualValor = this.getTipoAtualValor.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.changeBlurQtd = this.changeBlurQtd.bind(this);
    this.salvarItens = this.salvarItens.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.abrirPaginaRevisaoPedido = this.abrirPaginaRevisaoPedido.bind(this);
    this.gravarPedidoStorage = this.gravarPedidoStorage.bind(this);
    this.abrirPaginasEtapa = this.abrirPaginasEtapa.bind(this);
    this.verificaAutenticacao = this.verificaAutenticacao.bind(this);

    this.state = {
      idPedido: null,
      actionPage: "CADASTRAR",
      pedido: null,
      valorTotalCarrinho: 0,
      vendedor: null,
      modal: false,
      sequencia: null,
      usuario: null,
      parametros: null,
      modalFilter: false,
      comissao: 0,
    };
  }

  async componentDidMount() {
    let idPedido = queryString.parse(this.props.location.search).id;
    this.verificaAutenticacao();
    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });

    let actionPage = this.state.actionPage;

    if (idPedido !== undefined) {
      actionPage = "EDITAR";
    }

    this.setState(
      {
        db,
        idPedido,
        actionPage,
      },
      async () => {
        let pedidoStorage = null;

        if (this.state.actionPage === "CADASTRAR") {
          pedidoStorage = localStorage.getItem("pedido");
        } else if (this.state.actionPage === "EDITAR") {
          pedidoStorage = localStorage.getItem("orcamento");
        }

        if (pedidoStorage !== null) {
          pedidoStorage = JSON.parse(pedidoStorage);

          let itens = pedidoStorage.itens;

          for (let i = 0; i < itens.length; i++) {
            itens[i].sequencia = i;
            itens[i].quantidadeString = itens[i].quantidade;
            itens[i].estoque = await produtoModel.findEstoque(
              db,
              itens[i].produto._id
            );
            itens[i].valorComissao = 0;
          }
          pedidoStorage.itens = itens;

          this.setState({ pedido: pedidoStorage }, async () => {
            localStorage.setItem("lastPage", "adicionarItens");
            await this.loadUsuario(db);
            await this.loadParametros(db);
            await this.calcularTotalCarrinho();
          });
        } else {
          this.props.history.push("/home");
        }
      }
    );
  }

  removeItemCarrinho() {
    let sequencia = this.state.sequencia;
    let localPedido = JSON.parse(JSON.stringify(this.state.pedido));
    let item = localPedido.itens.find((i) => i.sequencia === sequencia);

    if (item !== undefined) {
      localPedido.itens = localPedido.itens.filter(
        (i) => i.sequencia !== sequencia
      );

      localStorage.setItem("pedido", JSON.stringify(localPedido));
      this.setState({ pedido: localPedido }, () => {
        this.calcularTotalCarrinho();
        this.toggle();
      });
      this.notificar("success", "Item removido do carrinho");
    }
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  async loadUsuario(db) {
    const usuario = await usuarioModel.find(db);
    const pedido = this.state.pedido;
    let vendedorFind = await vendedorModel.buscarPorIdIntegracao(
      db,
      pedido.cliente.vendedor.idIntegracao
    );

    let descontoTotal = 0;
    let acrescimoTotal = 0;

    // for (let itemProduto of pedido.itens) {
    //   if (itemProduto.produto.preco.valorAcrescimo > 0) {
    //     acrescimoTotal +=
    //       itemProduto.produto.preco.valorAcrescimo *
    //       parseFloat(itemProduto.quantidade);
    //   }

    //   if (itemProduto.produto.preco.valorDesconto > 0) {
    //     descontoTotal +=
    //       itemProduto.produto.preco.valorDesconto *
    //       parseFloat(itemProduto.quantidade);
    //   }
    // }

    // let novoSaldo = vendedorFind.vlOver + acrescimoTotal;
    // novoSaldo -= descontoTotal;
    // vendedorFind.vlOver = novoSaldo;

    await this.setState({ vendedor: vendedorFind, usuario });
  }

  calcularTotalCarrinho() {
    let produtosAdicionar = this.state.pedido.itens;
    let valorTotalCarrinho = 0;

    for (let item of produtosAdicionar) {
      if (item.quantidade > 0) {
        let valor = item.produto.preco.precoUnitComImpostosFinal;
        let condPagto = this.state.pedido.condPagto;
        let desconto = this.state.pedido.desconto;

        // if (this.state.parametros.tipoDesconto === "progressivo") {
        //   if (desconto !== null && desconto.pDesc !== 0) {
        //     valor = this.calcularValorDesconto(valor, desconto.pDesc);
        //   }
        // } else {
        //   if (condPagto !== null && condPagto.pDesc !== 0) {
        //     valor = this.calcularValorDesconto(valor, condPagto.pDesc);
        //   }
        // }

        valor = valor * item.quantidade;
        valorTotalCarrinho += valor;
        item.valorTotalItem = valor;
      }
    }

    let comissao = 0;
    let pedido = this.state.pedido;

    for (let item of pedido.itens) {
      if (item.produto.comissao !== undefined && item.produto.comissao !== 0) {
        let valor = parseFloat(
          (
            (item.produto.comissao *
              (item.produto.preco.precoUnitComImpostosFinal *
                item.quantidade)) /
            100
          ).toFixed(2)
        );
        comissao += valor;
        item.valorComissao = valor;
      } else {
        item.valorComissao = 0;
      }
    }

    this.setState({ valorTotalCarrinho, comissao, pedido });
  }

  calcularValorDesconto(valor, porcentagemDesconto) {
    valor = parseFloat(valor.toFixed(2));
    return valor - valor * (porcentagemDesconto / 100);
  }

  toggle() {
    this.setState({ modal: !this.state.modal });
  }

  async loadParametros() {
    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });

    let query = {
      selector: {
        type: { $eq: "parametros" },
      },
      limit: 1,
    };

    let result = await db.find(query);
    let parametros = result.docs[0];

    this.setState({ parametros });
  }

  onClickButtonQtd(item, tipo) {
    let produto = item.produto;
    let quantidade = item.quantidade;

    if (tipo === "INCREMENTAR") {
      let emb = parseFloat(produto.preco.embPadrao);
      if (emb === 0) emb = 1;
      let valor = quantidade + emb;
      this.handleChangeQtd(valor, item.sequencia);
    } else if (tipo === "DECREMENTAR") {
      let emb = parseFloat(produto.preco.embPadrao);
      if (emb === 0) emb = 1;

      let valor = quantidade - emb;

      if (valor > 0) {
        this.handleChangeQtd(valor, item.sequencia);
      }
    }
  }

  handleChangeQtd(value, sequencia) {
    let localProdutos = this.state.pedido.itens;

    if (value === "") {
      value = "0";
    }

    for (let item of localProdutos) {
      if (item.sequencia === sequencia) {
        let produto = item.produto;
        let quantidadeInputValida = true;
        let quantidadeInput = parseFloat(value);
        let produtoQtdCarrinho = quantidadeInput;

        if (produto.fracionado !== undefined && !produto.fracionado) {
          quantidadeInput = parseInt(quantidadeInput);
        }

        for (let itemProduto of localProdutos) {
          if (
            itemProduto.produto._id === produto._id &&
            itemProduto.sequencia !== sequencia
          ) {
            produtoQtdCarrinho += itemProduto.quantidade;
          }
        }

        if (VALIDAR_ESTOQUE && produtoQtdCarrinho > item.estoque) {
          quantidadeInputValida = false;
        }

        if (quantidadeInputValida) {
          if (
            item.quantidade !== quantidadeInput &&
            this.state.parametros.tipoDesconto === "over"
          ) {
            let tipoAtual = this.getTipoAtualValor(produto.preco);

            let saldoOver = parseFloat(this.state.vendedor.vlOver);

            if (tipoAtual === "ACRESCIMO") {
              let diferenca = Math.abs(item.quantidade - quantidadeInput);
              if (item.quantidade < quantidadeInput) {
                saldoOver += diferenca * produto.preco.valorAcrescimo;
              } else {
                saldoOver -= diferenca * produto.preco.valorAcrescimo;
              }
            } else if (tipoAtual === "DESCONTO") {
              let diferenca = Math.abs(item.quantidade - quantidadeInput);

              if (item.quantidade < quantidadeInput) {
                saldoOver -= diferenca * produto.preco.valorDesconto;
                if (saldoOver < 0) {
                  this.notificar("warning", "Não existe saldo over disponível");
                  item.quantidadeString = item.quantidade;
                  this.setState(
                    { pedido: { ...this.state.pedido, itens: localProdutos } },
                    () => {
                      this.calcularTotalCarrinho();
                    }
                  );
                  return false;
                }
              } else {
                saldoOver += diferenca * produto.preco.valorDesconto;
              }
            }

            let localVendedor = this.state.vendedor;
            localVendedor.vlOver = saldoOver;

            this.setState({ vendedor: localVendedor }, () => {
              this.calcularTotalCarrinho();
            });
          }

          item.quantidade = quantidadeInput;
          item.quantidadeString = quantidadeInput;
        } else {
          item.quantidadeString = item.quantidade;
          this.notificar(
            "warning",
            "Digite uma quantidade válida conforme estoque"
          );
        }
      }
    }
    this.setState(
      { pedido: { ...this.state.pedido, itens: localProdutos } },
      () => {
        this.calcularTotalCarrinho();
        this.salvarItens();
      }
    );
  }

  getTipoAtualValor(preco) {
    if (preco.pAcrescimo > 0) {
      return "ACRESCIMO";
    } else if (preco.pDesconto > 0) {
      return "DESCONTO";
    } else {
      return "NONE";
    }
  }

  handleFocus(event) {
    event.target.select();
  }

  changeBlurQtd(value, sequencia) {
    let localProdutos = this.state.pedido.itens;

    if (value === "") {
      value = "0";
    }

    if (value === "0") {
      value = "1";
    }

    for (let item of localProdutos) {
      let produto = item.produto;
      if (item.sequencia === sequencia) {
        item.quantidadeString = parseFloat(value);
        if (produto.fracionado !== undefined && !produto.fracionado) {
          item.quantidadeString = parseInt(item.quantidadeString);
        }
      }
    }
    this.setState(
      { pedido: { ...this.state.pedido, itens: localProdutos } },
      () => {
        this.calcularTotalCarrinho();
      }
    );
  }

  salvarItens() {
    let pedido = null;
    if (this.state.actionPage === "CADASTRAR") {
      pedido = localStorage.getItem("pedido");
    } else if (this.state.actionPage === "EDITAR") {
      pedido = localStorage.getItem("orcamento");
    }
    pedido = JSON.parse(pedido);
    let itens = [].concat(this.state.pedido.itens);
    pedido.itens = itens;

    if (this.state.actionPage === "CADASTRAR") {
      localStorage.setItem("pedido", JSON.stringify(pedido));
    } else if (this.state.actionPage === "EDITAR") {
      localStorage.setItem("orcamento", JSON.stringify(pedido));
    }
  }

  toggleFilter() {
    this.setState({ modal: !this.state.modalFilter });
  }

  abrirPaginaRevisaoPedido() {
    if (this.state.pedido.cliente === null) {
      return false;
    }
    let url = "/pedidos-revisao";

    if(this.state.actionPage === "CADASTRAR"){
      localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
    }else if(this.state.actionPage === "EDITAR"){
      localStorage.setItem("orcamento", JSON.stringify(this.state.pedido));
      url = url + `?id=${this.state.idPedido}`;
    }

    return this.props.history.push(url);
  }

  gravarPedidoStorage() {
    if (this.state.pedido.cliente === null) {
      this.notificar("warning", "Escolha o cliente");
      return false;
    }
    let url = `/adicionar-itens?cliente=${this.state.pedido.cliente.idIntegracao}`;

    if(this.state.actionPage === "CADASTRAR"){
      localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
    }else if(this.state.actionPage === "EDITAR"){
      localStorage.setItem("orcamento", JSON.stringify(this.state.pedido));
      url = url + `&id=${this.state.idPedido}`;
    }
    this.props.history.push(url);
  }

  abrirPaginasEtapa(pagina) {
    if (pagina !== "pedido" && this.state.pedido.cliente === null) {
      this.notificar("warning", "Selecione o cliente para continuar!");
      return false;
    }

    if(this.state.actionPage === "CADASTRAR"){
      localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
    }else if(this.state.actionPage === "EDITAR"){
      localStorage.setItem("orcamento", JSON.stringify(this.state.pedido));
    }

    let url = "";

    if (pagina === "pedido") {
      url = "/pedidos-novo";
    } else if (pagina === "pedidoInfo") {
      url = "/pedidos-novo-info";
    } else if (pagina === "carrinho") {
      url = "/carrinho";
    } else if (pagina === "revisao") {
      url = "/pedidos-revisao";
    }
    if (this.state.actionPage === "EDITAR") {
      url = url + `?id=${this.state.idPedido}`;
    }
    this.props.history.push(url);
  }

  async verificaAutenticacao() {
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/verifica-autenticacao-pedidos`,
        {
          idUsuario: localStorage.getItem("idUsuario"),
          hash: localStorage.getItem("hash"),
        },
        this.props.parameters()
      )
      .then((response) => {
        if (!response.data.valido) {
          this.props.logout();
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title={`Itens do ${this.state.actionPage === "CADASTRAR" ? 'Pedido' : 'Orçamento'}`} />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"novoPedido"} />
            <div className="main-panel">
              <div className="content-wrapper" style={{ position: "relative" }}>
                {/* <TitleAndDescription
                  title={`Cadastrar Pedido`}
                  description="Adicionar um novo pedido"
                /> */}

                <div>
                  <ul
                    id="alterUl"
                    className="nav nav-tabs justify-content-center process-model more-icon-preocess"
                    role="tablist"
                  >
                    <li
                      id="li-cliente"
                      role="presentation"
                      className="active"
                      onClick={() => {
                        this.abrirPaginasEtapa("pedido");
                      }}
                    >
                      <a
                        aria-controls="discover"
                        role="tab"
                        data-toggle="tab"
                      >
                        <i className="fa fa-plus" aria-hidden="true"></i>
                        <p>Pedido</p>
                      </a>
                    </li>

                    <li
                      id="li-info"
                      role="presentation"
                      className="active"
                      onClick={() => {
                        this.abrirPaginasEtapa("pedidoInfo");
                      }}
                    >
                      <a
                        aria-controls="content"
                        role="tab"
                        data-toggle="tab"
                      >
                        <i className="fa fa-newspaper-o" aria-hidden="true"></i>
                        <p>Info adicionais</p>
                      </a>
                    </li>
                    <li id="li-info" role="presentation" className="active">
                      <a
                        aria-controls="content"
                        role="tab"
                        data-toggle="tab"
                      >
                        <i
                          className="fa fa-shopping-cart"
                          aria-hidden="true"
                        ></i>
                        <p>Itens</p>
                      </a>
                    </li>
                    <li
                      id="li-info"
                      role="presentation"
                      onClick={() => {
                        this.abrirPaginasEtapa("revisao");
                      }}
                    >
                      <a
                        aria-controls="content"
                        role="tab"
                        data-toggle="tab"
                      >
                        <i className="fa fa-edit" aria-hidden="true"></i>
                        <p>Revisão</p>
                      </a>
                    </li>
                  </ul>
                </div>

                <div
                  className="row font-size-13"
                  style={{ position: "relative" }}
                >
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                <div className="row">
                                  <div className="table-responsive">
                                    <table className="table table-striped">
                                      <thead className="thead-dark">
                                        <tr>
                                          <th scope="col">Item</th>
                                          <th
                                            scope="col"
                                            className="text-right"
                                          >
                                            Estoque
                                          </th>
                                          <th
                                            scope="col"
                                            className="text-right"
                                          >
                                            Qtd
                                          </th>
                                          <th scope="col" className="">
                                            Ajustar
                                          </th>
                                          <th
                                            scope="col"
                                            className="text-right"
                                          >
                                            Valor
                                          </th>
                                          <th
                                            scope="col"
                                            className="text-right"
                                          >
                                            Valor Total
                                          </th>
                                          {/* <th
                                            scope="col"
                                            className="text-right"
                                          >
                                            Total Comissão
                                          </th> */}
                                          {/* <th scope="col">Rua</th>
                                        <th scope="col">Bairro</th>
                                        <th scope="col">Cidade</th> */}
                                          <th
                                            scope="col"
                                            className="text-center"
                                          >
                                            Ações
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.pedido !== null &&
                                          this.state.pedido.itens.map(
                                            (item, index) => (
                                              <tr>
                                                <td
                                                  style={{ maxWidth: "300px" }}
                                                >
                                                  <span
                                                    style={{
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    ({item.produto.cod})
                                                  </span>{" "}
                                                  - {item.produto.desc} -{" "}
                                                  <span
                                                    style={{
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Embalagem:
                                                  </span>{" "}
                                                  {item.produto.preco.embPadrao}{" "}
                                                  {item.produto.unid}
                                                  {/* <div
                                                    style={{ marginTop: "3px" }}
                                                  >
                                                    Embalagem:{" "}
                                                    {
                                                      item.produto.preco
                                                        .embPadrao
                                                    }{" "}
                                                    {item.produto.unid}
                                                  </div> */}
                                                  <div
                                                    style={{ marginTop: "3px" }}
                                                  >
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      OBS:
                                                    </span>{" "}
                                                    {item.produto.obsItemNovo}
                                                  </div>
                                                </td>
                                                <td className="text-right">
                                                  {item.estoque
                                                    .toString()
                                                    .replace(".", ",")}{" "}
                                                  {item.produto.unid}
                                                </td>
                                                <td
                                                  className="text-right"
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "end",
                                                  }}
                                                >
                                                  {/* {item.quantidadeString} */}

                                                  <input
                                                    type="number"
                                                    inputMode="decimal"
                                                    min="0"
                                                    value={
                                                      item.quantidadeString
                                                    }
                                                    onFocus={this.handleFocus}
                                                    className={
                                                      "form-control teste20"
                                                    }
                                                    onBlur={(e) => {
                                                      this.handleChangeQtd(
                                                        e.target.value,
                                                        item.sequencia
                                                      );
                                                    }}
                                                    onChange={(e) =>
                                                      this.changeBlurQtd(
                                                        e.target.value,
                                                        item.sequencia
                                                      )
                                                    }
                                                    style={{
                                                      maxWidth: "80px",
                                                      position: "relative",
                                                      top: "-4px",
                                                    }}
                                                    //onFocus={this.handleFocus}
                                                  />
                                                </td>
                                                <td
                                                  className="text-right"
                                                  style={{}}
                                                >
                                                  {/* <div
                                                  style={{ marginRight: "2px" }}
                                                >
                                                 
                                                </div> */}

                                                  <span
                                                    className="span-qtd float-left"
                                                    style={{
                                                      backgroundColor:
                                                        "#DC494A",
                                                      width: "90%",
                                                      marginRight: "3px",
                                                      textAlign: "center",
                                                    }}
                                                    onClick={(e) => {
                                                      this.onClickButtonQtd(
                                                        item,
                                                        "DECREMENTAR"
                                                      );
                                                    }}
                                                  >
                                                    <i className="fa fa-minus" />
                                                  </span>

                                                  <span
                                                    className="span-qtd float-left"
                                                    style={{
                                                      backgroundColor:
                                                        "#7ED321",
                                                      width: "90%",
                                                      marginRight: "10%",
                                                      textAlign: "center",
                                                    }}
                                                    onClick={(e) => {
                                                      this.onClickButtonQtd(
                                                        item,
                                                        "INCREMENTAR"
                                                      );
                                                    }}
                                                  >
                                                    <i className="fa fa-plus" />
                                                  </span>
                                                </td>
                                                <td className="text-right">
                                                  R${" "}
                                                  {formatarRealCarrinho(
                                                    item.produto.preco
                                                      .precoUnitComImpostosFinal
                                                  )}
                                                </td>
                                                <td className="text-right">
                                                  R${" "}
                                                  {formatarRealCarrinho(
                                                    item.valorTotalItem
                                                  )}
                                                </td>
                                                {/* <td className="text-right">
                                                  R${" "}
                                                  {formatarRealCarrinho(
                                                    item.valorComissao
                                                  )}
                                                </td> */}
                                                <td className="text-center">
                                                  <img
                                                    className="img-responsive"
                                                    src={"../images/trash.svg"}
                                                    alt="trash"
                                                    style={{
                                                      width: "25px",
                                                      cursor: "pointer",
                                                      position: "relative",
                                                      top: "-10px",
                                                    }}
                                                    onClick={() => {
                                                      this.setState(
                                                        {
                                                          sequencia:
                                                            item.sequencia,
                                                        },
                                                        () => {
                                                          this.removeItemCarrinho();
                                                        }
                                                      );
                                                    }}
                                                  />
                                                </td>
                                              </tr>
                                            )
                                          )}

                                        {/* <tr>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td
                                            style={{
                                              fontSize: "16px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Valor total:{" "}
                                            <span style={{ color: "#5f9f1a" }}>
                                              R${" "}
                                              {formatarReal(
                                                this.state.valorTotalCarrinho
                                              )}
                                            </span>
                                          </td>
                                        </tr> */}

                                        {/* {this.state.enderecos.map(
                                      (endereco, key) => (
                                        <tr>
                                          <th scope="row">{endereco.cep}</th>
                                          <td>
                                            {endereco.principal
                                              ? "(Principal)"
                                              : "Secundário"}{" "}
                                          </td>
                                          <td>
                                            {endereco.endereco}, n°{" "}
                                            {endereco.numero}
                                          </td>
                                          <td>{endereco.bairro}</td>
                                          <td>
                                            {endereco.cidade} -{" "}
                                            {endereco.estado}
                                          </td>
                                          <td className="text-center">
                                            <img
                                              className="img-responsive"
                                              src={"../../images/trash.svg"}
                                              alt="trash"
                                              style={{
                                                width: "20px",
                                                marginTop: "-4px",
                                              }}
                                              onClick={(e) =>
                                                this.removeEndereco(
                                                  endereco.sequencia
                                                )
                                              }
                                            />
                                          </td>
                                        </tr>
                                      )
                                    )} */}
                                      </tbody>
                                    </table>
                                  </div>

                                  <div
                                    style={{
                                      float: "left",
                                      padding: "10px",
                                      textAlign: "center",
                                      width: "100%",
                                    }}
                                  >
                                    {/* <button
                                      className="btn btn-success btn-app-pedidos-verde"
                                      onClick={() => this.gravarPedidoStorage()}
                                    >
                                      Adicionar itens
                                    </button> */}

                                    <span
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => this.gravarPedidoStorage()}
                                    >
                                      + Adicionar Itens
                                    </span>
                                  </div>

                                  {/* <div
                                    style={{
                                      float: "left",
                                      width: "100%",
                                      textAlign: "right",
                                      padding: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Valor total:{" "}
                                      <span style={{ color: "#5f9f1a" }}>
                                        R${" "}
                                        {formatarReal(
                                          this.state.valorTotalCarrinho
                                        )}
                                      </span>
                                    </div>
                                  </div> */}
                                </div>

                                <div className="row">
                                  <div className="col-md-12 pd-pedido">
                                    <div className="form-group">
                                      <button
                                        className="btn btn-success"
                                        onClick={this.abrirPaginaRevisaoPedido}
                                      >
                                        Próximo
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      position: "relative",
                      textAlign: "center",
                      //width: "calc(100% - 257px)",
                      width: "100%",
                      textAlign: "center",
                      //paddingRight: "35px",
                    }}
                  >
                    <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                      Valor total:{" "}
                      <span style={{ color: "rgb(126, 211, 33)" }}>
                        R$ {formatarReal(this.state.valorTotalCarrinho)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
